import * as React from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';

var RadioWrapper = function (_a) {
    var onClick = _a.onClick, label = _a.label, selected = _a.selected, className = _a.className, disabled = _a.disabled, children = _a.children, variantClass = _a.variantClass;
    return (React.createElement("div", { "aria-checked": selected, "aria-disabled": !!disabled, className: classNames('nv-radio-button-wrapper', variantClass, className), "cy-test": label, "data-testid": "radio-wrapper", onClick: selected || disabled ? noop : onClick, onKeyDown: selected || disabled ? noop : onClick, role: "radio", tabIndex: 0 }, children));
};

export { RadioWrapper as default };
//# sourceMappingURL=RadioWrapper.esm.js.map
